import { graphql, useLazyLoadQuery } from "react-relay";

import { useMCPEnabled } from "app/hooks/feature-flags/useMCPEnabled/useMCPEnabled";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { McpSettings } from "./McpSettings";
import { McpSettingsPage } from "./McpSettingsPage";

import type { McpSettingsRootQuery } from "./__generated__/McpSettingsRootQuery.graphql";

export function McpSettingsRoot() {
  const data = useLazyLoadQuery<McpSettingsRootQuery>(
    graphql`
      query McpSettingsRootQuery {
        ...McpSettingsPage_query
        ...useMCPEnabled_query
      }
    `,
    {},
  );

  // `mcp_url` in the deployment's config is the whole enablement signal, so the
  // switch and the install instructions read from the same place: without an
  // endpoint there is nothing to point a client at, and nothing to switch on.
  const { isEnabled, url } = useMCPEnabled(data);

  return (
    <McpSettingsPage queryRef={data}>
      <SettingsTabsLayout>
        <McpSettings isEnabled={isEnabled} url={url} />
      </SettingsTabsLayout>
    </McpSettingsPage>
  );
}
